export default "__VITE_ASSET__DWjkBd6c__"